<script setup lang="ts">
import { computed, ref, onMounted } from 'vue';
import { BFormInput } from 'bootstrap-vue-next';
import type { IColumnDefinition, RowData } from '../types';

const props = defineProps<{
  modelValue: any;
  row: RowData;
  column: IColumnDefinition;
  autofocus?: boolean;
}>();
const emit = defineEmits(['update:modelValue', 'change']);
const inputRef = ref<any>(null);

const currentValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

onMounted(() => {
  if (props.autofocus && inputRef.value) {
    const el = inputRef.value;
    if (el.element && el.element.focus) {
      el.element.focus();
    } else if (el.focus) {
      el.focus();
    }
  }
});
</script>

<template>
  <BFormInput
    ref="inputRef"
    v-model="currentValue"
    type="text"
    size="sm"
    :name="column.name"
    :placeholder="column.placeholder"
    :disabled="column.editorIsDisabled ? column.editorIsDisabled(row) : false"
    @change="emit('change', currentValue)"
    @click.stop
  />
</template>
